import React from 'react';
import AuthService from './authService';
import TpClientInvoiceJobLine from '../Domain/TpClientInvoiceJobLine';
import SearchParams from '../Elements/SearchParams';
import TpClientInvoiceJobLineSearchParams from '../Contents/Operations/TpClientInvoice/Details/TpClientInvoiceJobLineSearchParams';

export default class TpClientInvoiceJobLineService extends React.Component {
  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(
      searchItem,
      TpClientInvoiceJobLineSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );
    return AuthService.getInstance().CallBackendFunction(
      `/api/TpClientInvoiceJobLine/GetListBySearchingAsync?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`
    );
  }

  static ConvertDBItems(items) {
    const convertedItems = [];
    if (items !== null) {
      items.forEach((item) => {
        const newItem = new TpClientInvoiceJobLine(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static ExportToExcel(searchItem) {
    return AuthService.getInstance().CallBackendFunction(
      `/api/TpClientInvoiceJobLine/JobLineExcelExportAsync/?searchParams=${JSON.stringify(searchItem)}&clearCache=true`
    );
  }

  static MultipleEdit(editItem, searchItem, selected, allItemsInTheSearchSetAreSelected) {
    editItem.JobIds = selected.map((item) => item.TpJobId);
    editItem.AllItemsInTheSearchSetAreSelected = allItemsInTheSearchSetAreSelected;

    return AuthService.getInstance().CallBackendFunctionPost(
      '/api/TpClientInvoiceJobLine/MultipleEditAsync/?searchParams=' + JSON.stringify(searchItem),
      JSON.stringify(editItem)
    );
  }

  static GenerateManualEvaluatorIob(editItem, selected, tpClientInvoiceId) {
    const request = {
      TpClientInvoiceId: tpClientInvoiceId,
      TpJobIds: selected.map((i) => i.TpJobId),
      InvoicingOfficeId: editItem.InvoicingOfficeId,
      InvoicedOfficeId: editItem.InvoicedOfficeId,
      InternalReference: editItem.InternalReference,
      Comment: editItem.Comment,
    };

    return AuthService.getInstance().CallBackendFunctionPost(
      '/api/IobInvoiceMicro/GenerateManualEvaluatorIob',
      JSON.stringify(request)
    );
  }
}
